const PricingHeaderSection = () => {
  return (
    <section className="pt-20 pb-8 md:pt-[200px] md:pb-24 bg-alter-beige px-6 md:px-20">
      <div className="width-1440">
        <h1 className="font-light text-3.5xl md:text-5xl pb-2 md:pb-4">Our Pricing</h1>
        <p className="font-light text-xl text-alter-black-60">
          Easy payment options, affordable for everyone.
        </p>
      </div>
    </section>
  );
};

export default PricingHeaderSection;
